var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{staticClass:"px-md-4",attrs:{"id":"navbar","app":"","color":"primary","clipped-left":_vm.$vuetify.rtl,"clipped-right":!_vm.$vuetify.rtl,"flat":""}},[_c('default-navigation',{staticClass:"d-flex align-center",attrs:{"color":"","dark":""}}),_c('v-spacer'),_c('default-account')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }